import React from "react";
import {
  FaFacebook,
  FaInstagramSquare,
  FaTwitterSquare,
  FaLinkedin,
} from "react-icons/fa";
import { footerLinks, policyLinks } from "./utils/navLinks";
import { Link } from "react-router-dom";
import { useNavContext } from "../../context-api/nav-context";
/* import logo from "../../Assets/Images/navbar/logoshort.png"; */

const Footer = () => {
  const { closeNavbarMenu } = useNavContext();
  return (
    <section className="footer" onMouseOver={closeNavbarMenu}>
      <div className="section-wrapper footer-flex">
        <div className="footer-left_column">
          <div className="footer-img-container">
            <img
              src="https://res.cloudinary.com/duwmjod0j/image/upload/q_80/v1642174751/AquaHeat/Navbar%20Images/logoshort_llwi5s.webp"
              alt="AquaHeat Plumbing & Heating"
            />
          </div>
          <p className="footer-copyright">
            ©2021 AquaHeat Plumbing & Heating LTD. All rights reserved.
          </p>
          <p className="footer-main-p">
            AquaHeat Plumbing & Heating LTD is authorised and regulated by the
            Financial Conduct Authority. Finance options are provided by
            Hitatchi Finance. Finance available subject to status. Terms and
            conditions apply. AquaHeat acts as a credit broker and is not a
            lender. Any credit is subject to status, affordability and a credit
            check. Registered in England & Wales company No. 08383496 VAT No.
            154110651.
          </p>
          <div className="footer-social">
            <FaFacebook className="social fb" />{" "}
            <FaInstagramSquare className="social in" />{" "}
            <FaTwitterSquare className="social tw" />{" "}
            <FaLinkedin className="social lk" />
          </div>
        </div>
        <div className="footer-right_column">
          <div className="footer-right_column-col1">
            <ul className="footer-list">
              {footerLinks.map((item) => {
                const { id, text, url } = item;
                return (
                  <li key={id} className="footer-list-item">
                    <Link to={url} className="navbar-links footer-links">
                      {text}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="footer-right_column-col2">
            <ul className="footer-list">
              {policyLinks.map((item) => {
                const { id, url, text } = item;
                return (
                  <li key={id} className="footer-list-item">
                    <Link to={url} className="navbar-links footer-links">
                      {text}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
